import React, { useState, useEffect, useContext, useRef } from 'react';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { useNavigate } from 'react-router-dom';
import InvoiceService from "../Controller/InvoiceController";
import InvoiceDetailModal from "./InvoiceDetail";
import Common from '../../Common/Common';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import HelpSite from "../../Common/HelpLink";
import ShipInvoice from "./InvoiceForms/ShipInvoice";
import InvoiceShippedModel from "./InvoiceForms/InvoiceShippedModel";
import ModuleService from "../../Setup/controller/ModuleController/ModuleController";
import SageService from '../../Sage/Controller/SageController';
import Draggable from 'react-draggable';
import { useTranslation } from 'react-i18next';
import ColumnOptionDropDown from "../../Lead/Views/LeadForms/ColumnOptionDropDown";
import Cookies from "js-cookie";
import { formatDateWithFns } from '../../Common/DateInputFormat';
import useDateFormat from '../../Common/fetchDateFormat';
import LockReleaseService from "../../Setup/controller/LockReleaseController/LockModuleController";
import CompanySetupController from "../../SuperAdmin/Controller/Client/SACompanyListController";
import QuickbookService from '../../Quickbook/QuickbookController';
import XeroService from '../../Xero/XeroController';
import SendEmail from "../../Common/SendEmail";
import MultipleEmail from "../../Common/MultipleEmail";
import CustomerService from "../../Customer/Controller/CustomerController";
import MultiSearchDropDown from "../../Common/MultiSearchDropDown";
import JasperReportService from '../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../config/axiosInstance';
import SendAttachment from "../../Common/SendAttachment";
import ReportService from "../../Setup/controller/ReportController/ReportController";
import TermsConditionService from "../../Setup/controller/TermsConditionController/TermsConditionController";
import BASE_URL from "../../../config/config";
import { PDFDocument } from "pdf-lib";
function InvoiceList({ ClientCompanyID, JobTab }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const tableRef = useRef();
  const [modalInstance, setModalInstance] = useState(null);
  const { theme, toggleTheme } = useContext(ThemeContext);
  let accordTheme = "accordion-header-light";
  if (theme == "dark") {
    accordTheme = "accordion-header-dark";
  }
  const [InvoiceList, setInvoiceData] = useState([]);
  const [showAssetDetailModal, setShowAssetDetailModal] = useState(false); // State to control AssetDetailModal visibility
  const [modalInstanceInvoiceDetail, setModalInstanceInvoiceDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState("0");
  const [StockLocationList, setStockLocation] = useState([]);
  const [partList, setPartData] = useState([]);
  const [showShippedModal, setShowShippedModal] = useState(false);
  const [bnt_OrderNumber, set_bnt_OrderNumber] = useState("");
  const [saleOrderId, setInvoiceID] = useState("");
  const [InvoiceBalance, setInvoiceBalance] = useState();
  const [isModalBalance, setIsModalBalance] = useState(false);
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(1); // Total number of pages
  const [searchQuery, setSearchQuery] = useState('');
  const [soCount, setSOCount] = useState(0);
  const [multipleIds, setMultipleIds] = useState([]);
  const UserID = localStorage.getItem("UserID");
  const CompanyID = localStorage.getItem("CompanyID");
  const activeDateFormat = useDateFormat();
  const [showPayModal, setShowPayModal] = useState(false);
  const [payAmount, setPayAmount] = useState("0");
  const [totalPayment, setTotalPayment] = useState("0");
  const [invoiceAgedSummary, setInvoiceAgedSummary] = useState([]);
  const [recentSearches, setRecentSearches] = useState([]);
  const [pdfAttachment, setPdfAttachment] = useState(null);
  const setSortConfigInCookie = (config) => {
    Cookies.set(`InvoiceSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
  };
  const getSortConfigFromCookie = () => {
    const sortCookie = Cookies.get(`InvoiceSort_${CompanyID}_${UserID}`);
    return sortCookie ? JSON.parse(sortCookie) : { key: 'PK_Invoice_ID', direction: 'desc' };
  };
  const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());

  const setPageSizeInCookie = (pageSize) => {
    document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
  };
  const getPageSizeFromCookie = () => {
    const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
    return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
  };
  const [pageSize, setPageSize] = useState(getPageSizeFromCookie());
  const redirectCallback = () => {
    navigate('/'); // Redirect to the login page
  };



  const fetchInvoice = async (ClientCompanyID, page, size) => {
    try {

      setLoading(true);
      const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
      const PageSize = size.toString();

      const data = await InvoiceService.GetAllInvoice(redirectCallback, ClientCompanyID, Start.toString(), PageSize.toString(),
        searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns.toString());

      setInvoiceData(data);

      const sarderCount = await InvoiceService.GetInvoiceCount(redirectCallback, ClientCompanyID, searchQuery.toString(), searchColumns.toString());
      setSOCount(sarderCount[0].TotalRecords);
      setTotalPages(Math.ceil(sarderCount[0].TotalRecords / size));
    } catch (error) {
      console.error('Error fetching Teams:', error);
    } finally {
      setLoading(false); // Stop loading after fetching
    }
  };
  const fetchInvoiceAgedSummary = async (ClientCompanyID) => {
    try {

      setLoading(true);
      const data = await InvoiceService.CustomerInvoiceAgedSummary(ClientCompanyID);
      setInvoiceAgedSummary(data);
    } catch (error) {
      console.error('Error fetching Teams:', error);
    } finally {
      setLoading(false); // Stop loading after fetching
    }
  };
  const UserLockRelease = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const CompanyID = localStorage.getItem("CompanyID");
      if (CompanyID === null || CompanyID === "null") {
        redirectCallback();
      }
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "2");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "3");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "4");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "5");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "6");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "7");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "8");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "9");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "10");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "15");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "17");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "18");

    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };
  useEffect(() => {
    fetchInvoice(ClientCompanyID, currentPage, pageSize);
    fetchSearchLog();
    fetchInvoiceAgedSummary(ClientCompanyID);
  }, [ClientCompanyID, currentPage, pageSize]);
  useEffect(() => {
    fetchInvoice(ClientCompanyID, currentPage, pageSize);
    fetchInvoiceAgedSummary(ClientCompanyID);
  }, [ClientCompanyID, sortConfig]);
  useEffect(() => {
    IsModuleAssigned();
    UserLockRelease();

    fetchInvoice(ClientCompanyID, '0', pageSize);
    fetchInvoiceAgedSummary(ClientCompanyID);
  }, [ClientCompanyID, JobTab]);
  async function fetchSearchLog() {
    try {

      const searchList = await CustomerService.GetSearchLog("22");
      setRecentSearches(searchList);
    } catch (error) {
      console.error('Error fetching Roles:', error);
    }
  }
  const handleCloseModal = async (isChanged) => {

    const closeModal = async () => {
      await InvoiceService.UnLockInvoice(localStorage.getItem('InvoiceID'));
      if (localStorage.getItem('HasRecordUpdated') == "1") {
        await fetchInvoice(ClientCompanyID, '0', pageSize);
      }
      setMultipleIds([]);
      setIsModalOpen(false);

    };

    if (isChanged != true) {
      closeModal();
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: `Are you sure you want to close this record?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, close it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        closeModal();
      }
    });
  };

  const handleDeleteClick = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    if (multipleIds.length > 0) {
      Swal.fire({
        title: 'Are you sure?',
        text: `You are about to delete ${multipleIds.length} record(s). This cannot be undone!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await InvoiceService.DeleteInvoice(multipleIds);
            setMultipleIds([]);
            await fetchInvoice(ClientCompanyID, '0', pageSize);
            setSelectedId("0");
            Swal.fire(
              'Deleted!',
              'Your record has been deleted.',
              'success'
            );
          } catch (error) {
            console.error('Error deleting job:', error);
            Swal.fire(
              'Error!',
              'There was a problem deleting the record.',
              'error'
            );
          }
        }
      });
    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to delete invoice.',
        'warning'
      );
    }
  };
  const handleCreateInvoiceClick = () => {
    localStorage.setItem('InvoiceID', "");
    localStorage.setItem('InvoiceID', "0");
    localStorage.setItem('HasRecordUpdated', "0");
    setIsModalOpen(true);
  };
  const handleEditClick = async (InvoiceID) => {
    const IsAlreadyLeadID = localStorage.getItem('InvoiceID');
    if (IsAlreadyLeadID) {
      await InvoiceService.UnLockInvoice(IsAlreadyLeadID);
    }
    const saleOrderDetail = await fetchInvoiceDetail(InvoiceID);
    if (saleOrderDetail) {

      localStorage.setItem('InvoiceID', "");
      localStorage.setItem('InvoiceID', InvoiceID);
      localStorage.setItem('HasRecordUpdated', "0");
      setSelectedId(InvoiceID);
      setIsModalOpen(true);

    }
  };
  const truncateText = (text, maxLength = 15) => {
    if (!text) return '';  // Return empty string if text is null or empty
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };

  // Allocate and ship sale order
  const fetchInvoiceDetail = async (InvoiceID) => {
    try {
      const redirectCallback = () => navigate('/');
      if (InvoiceID > 0) {
        const saleOrderDetail = await InvoiceService.GetInvoiceByID(redirectCallback, InvoiceID);
        const saleOrder = saleOrderDetail[0];
        return saleOrder;
      }
    } catch (error) {
      console.error('Error fetching agreement details:', error);
    }
  };
  const handleCheckboxChange = (event, id) => {
    event.stopPropagation();
    setSelectedId((prevSelectedId) => (prevSelectedId === id ? "0" : id)); // Toggle selection
    setMultipleIds((prevSelectedIds) => {
      if (event.target.checked) {
        return [...prevSelectedIds, id];
      } else {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      }
    });
  };
  //----------------------------------------------------------------------------------------
  const handleSuccess = async () => {
    setShowShippedModal(false);
    await fetchInvoice(ClientCompanyID, '0', pageSize);
  };


  const { handleShipInvoice } = ShipInvoice(selectedId);

  const handleAllocateInvoice = async (event, part, index) => {
    event.stopPropagation();
    let ID = 0;
    for (const id of multipleIds) {
      ID = id;
    }
    if (ID > 0) {
      const saleOrderDetail = await fetchInvoiceDetail(ID);
      if (saleOrderDetail.snt_AllocatedStatus === 2) {
        Swal.fire(
          '',
          'The Selected invoice is already allocated',
          'Warning'
        );
      }
      else {
        if (saleOrderDetail.ContractInvoice > 0) {
          Swal.fire(
            '',
            'The Selected invoice can not be shipped as this order is generated from the Agreement',
            'Warning'
          );
        }
        else {
          if (saleOrderDetail.bit_DropShipment === 2 || saleOrderDetail.snt_AllocatedStatus === 2) {
            Swal.fire(
              '',
              'The Selected invoice is already allocated or shipped',
              'Warning'
            );
          }
          else {
            Swal.fire({
              title: 'Are you sure?',
              text: "You won't be able to revert this!",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, allocate it!'
            }).then(async (result) => {
              if (result.isConfirmed) {
                try {
                  setPartData([]);
                  setShowShippedModal(true);
                  debugger;
                  set_bnt_OrderNumber(saleOrderDetail.bnt_OrderNumber);
                  setInvoiceID(ID);
                  const InvoiceItemList = await handleShipInvoice(event, ID);
                  setPartData(InvoiceItemList);

                } catch (error) {

                }
              }
            });
          }
        }
      }
    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to delete invoice.',
        'warning'
      );
    }


  }
  const handleShippment = async (event, part, index) => {
    event.stopPropagation();
    let ID = 0;
    for (const id of multipleIds) {
      ID = id;
    }
    if (ID > 0) {
      const invoiceDetail = await fetchInvoiceByID(ID);
      if (invoiceDetail.bit_DropShipment === 2) {
        Swal.fire(
          '',
          'The Selected invoice is already shipped',
          'Warning'
        );
      }
      else {
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, post it!'
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              setPartData([]);
              set_bnt_OrderNumber(invoiceDetail.bnt_OrderNumber);
              const InvoiceItemList = await handleShipInvoice(event, ID);
              setPartData(InvoiceItemList);


              /*const postData = await InvoiceService.ShipInvoice(InvoiceID);
              if (postData.message === "Data saved successfully") {
                  localStorage.setItem('HasRecordUpdated', "1");
                  Swal.fire(
                      '',
                      'The Invoice shipped successfully.',
                      'success'
                  );
                  handleSuccess();
              }*/
            } catch (error) {

            }
          }

        });

      }


    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to delete invoice.',
        'warning'
      );
    }
  }

  const handleUnAllocate = async (event, part, index) => {
    event.stopPropagation();
    let ID = 0;
    for (const id of multipleIds) {
      ID = id;
    }
    if (ID > 0) {
      const saleOrderDetail = await fetchInvoiceDetail(ID);
      if (saleOrderDetail.snt_AllocatedStatus === 0 || saleOrderDetail.snt_AllocatedStatus === null) {
        Swal.fire(
          '',
          'The selected invoice is not allocated.',
          'Warning'
        );
      }
      else {
        if (saleOrderDetail.bit_DropShipment === 2) {
          Swal.fire(
            '',
            'The Selected invoice is already shipped',
            'Warning'
          );
        }
        else {
          Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to unallocate this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes!'
          }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                const postData = await InvoiceService.UnAllocateInvoice(ID);
                if (postData.message === "Data saved successfully") {
                  Swal.fire(
                    '',
                    'The invoice unallocated successfully.',
                    'success'
                  );
                  handleSuccess();
                }
              } catch (error) {

              }
            }

          });
        }
      }

    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to delete invoice.',
        'warning'
      );
    }
  }
  const fetchInvoiceByID = async (InvoiceID) => {
    try {
      const redirectCallback = () => navigate('/');
      if (InvoiceID > 0) {
        const saleOrderDetail = await InvoiceService.GetInvoiceByID(redirectCallback, InvoiceID);
        const saleOrder = saleOrderDetail[0];
        return saleOrder;
      }
    } catch (error) {
      console.error('Error fetching agreement details:', error);
    }
  };
  const handleCloseShippmentModal = async () => {
    await fetchInvoice(ClientCompanyID, '0', pageSize);
    setShowShippedModal(false);

  };
  const redirecttoUnAuthorzied = () => {
    navigate('/Unauthorized'); // Redirect to the login page
  };
  const IsModuleAssigned = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const CompanyID = localStorage.getItem("CompanyID");
      if (CompanyID === null || CompanyID === "null") {
        redirectCallback();
      }
      const Modules = await ModuleService.GetModuleByClientID(CompanyID, "22");
      if (Modules.length === 0) {
        Swal.fire(
          'UnAuthorzied Access!',
          'Sorry, You are not authorized to access this module.',
          'warning'
        );
        redirecttoUnAuthorzied();
      }
    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };
  const handleSynchronize = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    let ID = 0;
    for (const id of multipleIds) {
      ID = id;
    }

    if (ID) {
      const saleOrderDetail = await fetchInvoiceDetail(ID);

      if (saleOrderDetail.bit_DropShipment === 2 || saleOrderDetail.bit_DropShipment === "2") {
        if (saleOrderDetail.CustomerGuidID != null && saleOrderDetail.CustomerGuidID != "null") {
          Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Synchronize!'
          }).then(async (result) => {
            if (result.isConfirmed) {
              try {

                const postData = await InvoiceService.SyncInvoiceToFinancial(multipleIds);
                if (postData && postData.message === "Data saved successfully") {
                  Swal.fire(
                    'Success!',
                    'The data has been processed and will be fully synced shortly.',
                    'success'
                  );
                  await fetchInvoice(ClientCompanyID, '0', pageSize);
                }
              } catch (error) {
                console.error('Error Synchronizing data:', error);
                Swal.fire(
                  'Error!',
                  'There was a problem in synchronizing the record.',
                  'error'
                );
                await fetchInvoice(ClientCompanyID, '0', pageSize);
              }
            }

          });
        }
        else {
          Swal.fire(
            'Error!',
            'Please sync the selected customer with sage account.',
            'warning'
          );
        }
      }
      else {
        Swal.fire(
          'Error!',
          'The selected invoice cannot be synchronize before shippment.',
          'warning'
        );
      }
    }
    else {
      Swal.fire(
        'Error!',
        'Please select at least one record to synchronize.',
        'warning'
      );
    }

  };
  const handlePayInvoice = async (event) => {
    event.stopPropagation();
    if (multipleIds.length > 0 && ClientCompanyID > 0) {

      let ID = 0;
      for (const id of multipleIds) {
        ID = id;
      }
      const saleOrderDetail = await fetchInvoiceDetail(ID);

      if (saleOrderDetail.bit_DropShipment === 2 || saleOrderDetail.bit_DropShipment === "2") {
        // Instead of directly paying, show modal
        setShowPayModal(true);
      } else {
        Swal.fire(
          'Error!',
          'The selected invoice cannot be paid before shipment.',
          'warning'
        );
      }
    } else {
      Swal.fire(
        'Error!',
        'Please select the invoice to pay.',
        'warning'
      );
    }
  };

  const handleCustomerInvoiceRecord = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    debugger;
    const Invoice = await InvoiceService.CustomerInvoiceRecord(ClientCompanyID);
    setInvoiceBalance(Invoice);
    setIsModalBalance(true);
  };
  const handleStart = (e, ui) => {
    e.stopPropagation();
  }

  const handlePageChange = (page) => {
    setInvoiceData([]);
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);

    }
  };
  const handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    setPageSize(newPageSize);
    setPageSizeInCookie(newPageSize);
    setCurrentPage(1); // Reset to the first page
  };
  const handleSearchButtonClick = async () => {
    setCurrentPage(1); // Reset to first page
    setInvoiceData([]); // Clear previous data
    const query = searchQuery.toLowerCase(); // Use current searchQuery state
    let columnsToSearch = searchColumns.length > 0
      ? searchColumns.join(",")
      : "ALL";
    setSearchOptions(columnsToSearch);
    const purchaseOrderData = await InvoiceService.GetAllInvoice(redirectCallback, ClientCompanyID, currentPage, pageSize.toString(),
      query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), columnsToSearch.toString());
    setInvoiceData(purchaseOrderData);

    const soorderCount = await InvoiceService.GetInvoiceCount(redirectCallback, ClientCompanyID, searchQuery, columnsToSearch.toString());
    setSOCount(soorderCount[0].TotalRecords);
    setTotalPages(Math.ceil(soorderCount[0].TotalRecords / pageSize)); // Set total pages dynamically

    const searchList = await CustomerService.GetSearchLog("22");
    setRecentSearches(searchList);
  };
  const handleSort = async (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }

    const newConfig = { key, direction };
    setSortConfig(newConfig);
    setSortConfigInCookie(newConfig);
    setCurrentPage(1);

    setSortConfig({ key, direction });
    const sorderData = await InvoiceService.GetAllInvoice(redirectCallback, ClientCompanyID, "1", pageSize.toString(),
      searchQuery.toString(), key.toString(), direction.toString(), searchColumns.toString());

    const sorderCount = await InvoiceService.GetInvoiceCount(redirectCallback, ClientCompanyID, searchQuery, searchColumns.toString());

    setSOCount(sorderCount[0].TotalRecords);
    setInvoiceData(sorderData);

    setTotalPages(Math.ceil(sorderCount[0].TotalRecords / pageSize));
  };

  const defaultColumns = [
    "Invoice",
    "SSource",
    "SType",
    "SDate",
    "SDescription",
    "ISiteName",
    "SAmount",
    "SPaid",
    "SPrinted",
    "SShipped",
    "Stotal",
    "Sposted",
    "Spaid",
    "SourceNumber",
    "ModifiedBy",
  ];

  const columnOptions = [
    { value: "InvoiceNo", label: "Invoice No." },
    { value: "SSource", label: "Source" },
    { value: "SType", label: "Type" },
    { value: "SDate", label: "Date" },
    { value: "SDescription", label: "Description" },
    { value: "ISiteName", label: "Site" },
    { value: "Semail", label: "Email" },
    { value: "SAmount", label: "Amount" },
    { value: "SPaid", label: "Paid" },
    { value: "SPrinted", label: "Printed" },
    { value: "SShipped", label: "Shipped" },
    { value: "SSync", label: "	Sync" },
    { value: "SStatus", label: "	Status" },
    { value: "SourceNumber", label: "	SourceNumber" },
    { value: "ModifiedBy", label: "	ModifiedBy" },

  ];

  const getStoredColumns = () => {
    const storedColumns = Cookies.get(`InvoiceColumns_${CompanyID}`);
    return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
  };

  const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
  const handleColumnChange = (selectedOptions) => {
    setVisibleColumns(selectedOptions);

    // Save selection to cookies (valid for 1 year)
    Cookies.set(`InvoiceColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
  };
  const handleSubmitPayment = async () => {
    if (!payAmount || isNaN(payAmount) || payAmount <= 0) {
      Swal.fire('Error!', 'Please enter a valid amount.', 'warning');
      return;
    }

    try {

      let ID = 0;
      for (const id of multipleIds) {
        ID = id;
      }
      const Invoice = await InvoiceService.PayInvoice(ID, payAmount);
      if (Invoice.message === "Data saved successfully") {
        Swal.fire('Success!', 'Invoice paid successfully.', 'success');
        await fetchInvoice(ClientCompanyID, '0', pageSize);
      }
      setShowPayModal(false);
      setPayAmount(""); // Reset amount
    } catch (error) {
      Swal.fire('Error!', 'There was a problem processing the payment.', 'error');
    }
  };
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [Email, setEmail] = useState();
  const [ContactIDForEmail, setContactIDForEmail] = useState();
  const [isMultipleEmailModalOpen, setIsMultipleEmailModalOpen] = useState(false);
  const [multipleEmails, setMultipleEmails] = useState([]);
  const [lastCheckedIndex, setLastCheckedIndex] = useState(null);
  const handleEmailClick = async (event, contact) => {
    event.stopPropagation();
    setEmail(contact.Email);
    setContactIDForEmail(contact.FK_ClientContact_ID)
    setIsEmailModalOpen(true);
  };
  const handleCloseEmailModal = async () => {

    setIsEmailModalOpen(false);
    setIsMultipleEmailModalOpen(false);
    fetchInvoice("0", "0", pageSize);
  };
  const handleSendMultipleEmail = async () => {
    if (multipleIds.length > 0) {

      const emails = multipleIds
        .map(id => {
          const contact = InvoiceList.find(c => c.PK_Invoice_ID === id);
          return contact ? contact.Email : '';
        })
        .filter(email => email);
      setEmail(emails[0]);
      const id = multipleIds[0];
      const currentInputValues = {
        ClientID: localStorage.getItem("CompanyID"),
        paramInvoiceId: id
      };

      const JasperReport = await JasperReportService.GetJasperReportByID("111");
      let url = JasperReport[0].Link;
      debugger;
      Object.keys(currentInputValues).forEach((key) => {
        const placeholder = new RegExp(`{${key}}`, "g");
        url = url.replace(placeholder, currentInputValues[key]);
      });

      const queryObj = {
        ...currentInputValues,
        format: "pdf",
        ReportName: JasperReport[0].ReportName,
        ReportType: JasperReport[0].ReportType,
        name: JasperReport[0].ReportName
      };

      const queryString = new URLSearchParams(queryObj).toString();

      // 🔥 GET PDF as BLOB from API
      const response = await axiosInstance.get(`/Dashboard/ProxyReport?${queryString}`, {
        responseType: "blob",
      });

      // 🔥 Convert Blob → File
      const pdfFile = new File(
        [response.data],
        `${JasperReport[0].ReportName}.pdf`,
        { type: "application/pdf" }
      );

      // 🔥 Save to state (to send email)
      setPdfAttachment(pdfFile);

      // 🔥 Open Email Modal
      setIsMultipleEmailModalOpen(true);
    }
    else {
      Swal.fire('Error!', 'Please check at least one record.', 'warning');
    }
  }
  const handleCheckboxClick = (event, id, index) => {
    event.stopPropagation();

    const isChecked = event.target.checked;

    if (event.shiftKey && lastCheckedIndex !== null) {
      const start = Math.min(lastCheckedIndex, index);
      const end = Math.max(lastCheckedIndex, index);
      const idsInRange = InvoiceList.slice(start, end + 1).map(l => l.PK_Invoice_ID);

      setMultipleIds(prev => {
        const s = new Set(prev);
        if (isChecked) {
          idsInRange.forEach(x => s.add(x));     // range select
        } else {
          idsInRange.forEach(x => s.delete(x));  // range unselect
        }
        return Array.from(s);
      });
    } else {
      // normal single toggle
      setMultipleIds(prev => {
        const s = new Set(prev);
        if (isChecked) s.add(id); else s.delete(id);
        return Array.from(s);
      });
    }

    // Always update the anchor index
    setLastCheckedIndex(index);

  };
  const defaultColumnsForSearch = [
    "InvoiceNo",
    "SSource",
    "SType",
    "SDate",
    "SDescription",
    "ISiteName",
    "SAmount",
    "SPaid",
    "SPrinted",
    "SShipped",
    "Stotal",
    "Sposted",
    "Spaid",
    "SourceNumber",
    "ModifiedBy"
  ];
  const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
  const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
  const columnSearchOptions = [
    { value: "InvoiceNo", label: "Invoice No." },
    { value: "SSource", label: "Source" },
    { value: "SType", label: "Type" },
    { value: "SDate", label: "Date" },
    { value: "SDescription", label: "Description" },
    { value: "ISiteName", label: "Site" },
    { value: "Semail", label: "Email" },
    { value: "SAmount", label: "Amount" },
    { value: "SPaid", label: "Paid" },
    { value: "SPrinted", label: "Printed" },
    { value: "SShipped", label: "Shipped" },
    { value: "SSync", label: "	Sync" },
    { value: "SStatus", label: "	Status" },
    { value: "SourceNumber", label: "	SourceNumber" },
    { value: "ModifiedBy", label: "	ModifiedBy" },


  ];
  const handleSearchColumnChange = (selectedOptions) => {
    setSearchColumns(selectedOptions);

  };
  const handleExportExcel = async () => {

    if (multipleIds.length === 0) {
      Swal.fire(
        'Warning!',
        'Please select at least one record to export.',
        'warning'
      );
      return;
    }
    setLoading(true);
    try {

      // Filter only selected customers
      const selectedJob = InvoiceList.filter(job =>
        multipleIds.includes(job.PK_Invoice_ID)
      );

      if (!selectedJob || selectedJob.length === 0) {
        Swal.fire(
          'Warning!',
          'No selected data to export.',
          'warning'
        );
        return;
      }

      const headers = visibleColumns.map(col =>
        columnOptions.find(opt => opt.value === col)?.label || col
      );

      const rows = selectedJob.map(row =>
        visibleColumns.map(col => {
          let value = row[col];
          if (col === "InvoiceNo") {
            value = `${row.bnt_OrderNumber ?? ""}`;
          }
          if (col === "SSource") {
            value = `${row.InvoiceName ?? ""}`;
          }
          if (col === "SType") {
            value = `${row.vc_Name ?? ""}`;
          }
          if (col === "SorderDate") {
            value = `${row.dt_SalesOrderDate ?? ""}`;
          }
          if (col === "SStatus") {
            value = `${row.vc_StatusName ?? ""}`;
          }
          if (col === "SDate") {
            value = `${row.dt_InvoiceDate ?? ""}`;
          }
          if (col === "SDescription") {
            value = `${row.CompanyName ?? ""}`;
          }
          if (col === "Semail") {
            value = `${row.Email ?? ""}`;
          }
          if (col === "SAmount") {
            value = `${row.Total ?? ""}`;
          }
          if (col === "SPaid") {
            value = `${row.Paid ?? ""}`;
          }
          if (col === "SPrinted") {
            value = `${row.bit_Print ?? ""}`;
          }

          return `"${(value ?? '').toString().replace(/"/g, '""')}"`;
        }).join(',')
      );

      const csvContent = [
        headers.join(','), // CSV Header
        ...rows            // CSV Rows
      ].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Invoices.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error('Error exporting selected customers:', error);
    } finally {
      setLoading(false);
    }
  };

  const [showPdfModal, setShowPdfModal] = useState(false);
  const [imageData, setImageData] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [reportTitle, setReportTitle] = useState('');
  const [reportLink, setReportLink] = useState('');
  const [inputValues, setInputValues] = useState({});
  const [outputData, setOutputData] = useState([]);
  const [error, setError] = useState(null);


  const getMergedPDFBytes = async (id) => {
    try {
      const currentInputValues = {
        ClientID: localStorage.getItem("CompanyID"),
        ID: id
      };

      const redirectCallback = () => navigate('/');

      let reportData = await ReportService.GetCompanyReports(redirectCallback, "22");
      reportData = reportData.filter(x => x.IsDefault.toString() === "1");

      const reportID = reportData.length > 0 ? reportData[0].ID : 111;
      const JasperReport = await JasperReportService.GetJasperReportByID(reportID);

      const queryObjMain = {
        ...currentInputValues,
        format: 'pdf',
        ReportName: JasperReport[0].ReportName,
        ReportType: JasperReport[0].ReportType,
        name: JasperReport[0].ReportName
      };

      const responseMain = await axiosInstance.get(
        `/Dashboard/ProxyReport?${new URLSearchParams(queryObjMain)}`,
        { responseType: 'blob' }
      );

      const mainPdfBytes = await responseMain.data.arrayBuffer();

      const pdfDoc = await PDFDocument.load(mainPdfBytes);

      return pdfDoc;

    } catch (err) {
      console.error(err);
      return null;
    }
  };
  const handlePrintUser = async (event) => {
    event.stopPropagation();

    const result = await Swal.fire({
      title: "Include Terms & Conditions?",
      text: "Do you want to include Terms & Conditions in the print?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, include it",
      cancelButtonText: "No, just main report",
    });
    setLoading(true);
    const includeTerms = result.isConfirmed;

    if (multipleIds.length > 0) {
      try {
        const finalMergedPdf = await PDFDocument.create();

        // ================= MERGE INVOICES =================
        for (const id of multipleIds) {

          const pdfDoc = await getMergedPDFBytes(id);

          if (!pdfDoc) continue;

          const pages = await finalMergedPdf.copyPages(
            pdfDoc,
            pdfDoc.getPageIndices()
          );

          pages.forEach(page => finalMergedPdf.addPage(page));


          // ================= ADD TERMS ONLY ONCE =================
          if (includeTerms) {

            const companySetup = await CompanySetupController.GetCompanyByID(
              () => navigate('/'),
              localStorage.getItem("CompanyID")
            );

            const termFile = companySetup?.[0]?.TermFile;

            if (termFile) {
              const FileUrl = `${BASE_URL}/uploads/${localStorage.getItem('CompanyID')}/Admin/TermConditions/${termFile}`;

              const responseSecond = await axiosInstance.get(FileUrl, {
                responseType: 'blob'
              });

              const secondPdfBytes = await responseSecond.data.arrayBuffer();
              const secondPdf = await PDFDocument.load(secondPdfBytes);

              const secondPages = await finalMergedPdf.copyPages(
                secondPdf,
                secondPdf.getPageIndices()
              );

              secondPages.forEach(page => finalMergedPdf.addPage(page));
            }
          }
        }
        // ================= FINAL OUTPUT =================
        const finalBytes = await finalMergedPdf.save();
        const finalBlob = new Blob([finalBytes], { type: "application/pdf" });

        const finalUrl = URL.createObjectURL(finalBlob);
        setLoading(false);
        setPdfUrl(finalUrl);
        setShowPdfModal(true);

      } catch (err) {
        console.error('Error executing report:', err);
        setError('Failed to execute the report.');
      }
    } else {
      Swal.fire(
        'Error!',
        'Please check at least one record to print job.',
        'warning'
      );
    }
  };


  const getInitialWidths = () => {
    const saved = Cookies.get(`InvoiceColumnWidths_${CompanyID}_${UserID}`);
    const defaults = {};

    visibleColumns.forEach(col => {
      defaults[col] = 110;
    });

    if (!saved) return defaults;

    const parsed = JSON.parse(saved);
    const applied = {};

    visibleColumns.forEach(col => {
      applied[col] = parsed[col] || 110;
    });

    return applied;
  };

  const [columnWidths, setColumnWidths] = useState(getInitialWidths);
  const startX = useRef(0);
  const startWidth = useRef(0);
  const resizingColumn = useRef(null);
  const MIN_COL_WIDTH = 60;

  /**
   * Load widths from cookie when visibleColumns changes
   */
  useEffect(() => {
    const savedWidths = Cookies.get(`InvoiceColumnWidths_${CompanyID}_${UserID}`);
    if (savedWidths) {
      const parsed = JSON.parse(savedWidths);
      setColumnWidths((prev) => ({
        ...prev,
        ...parsed
      }));
    }
  }, [InvoiceList]);


  /**
   * Start Column Resize
   */
  const startResize = (e, key) => {
    e.stopPropagation();
    startX.current = e.clientX;
    resizingColumn.current = key;

    const th = e.target.closest("th");   // FIXED HERE
    startWidth.current = th.offsetWidth;

    document.addEventListener("mousemove", resizeColumn);
    document.addEventListener("mouseup", stopResize);
  };

  /**
   * Resize Column dynamically
   */
  const resizeColumn = (e) => {
    if (!resizingColumn.current) return;

    const delta = e.clientX - startX.current;
    const newWidth = Math.max(startWidth.current + delta, MIN_COL_WIDTH);

    setColumnWidths(prev => ({
      ...prev,
      [resizingColumn.current]: newWidth
    }));
  };
  useEffect(() => {
    setColumnWidths(getInitialWidths());
  }, [visibleColumns]);

  /**
   * Stop resizing and save to cookie
   */
  const stopResize = () => {
    document.removeEventListener("mousemove", resizeColumn);
    document.removeEventListener("mouseup", stopResize);

    const key = resizingColumn.current;
    if (key) {
      setColumnWidths(prev => {
        // Save using the most recent updated state
        Cookies.set(
          `InvoiceColumnWidths_${CompanyID}_${UserID}`,
          JSON.stringify(prev),
          { expires: 365 }
        );
        return prev;
      });
    }

    resizingColumn.current = null;
  };


  /**
   * Auto-fit column width
   */
  const autoFitColumn = (key) => {
    const cells = document.querySelectorAll(`[data-col='${key}']`);
    let maxWidth = 0;

    cells.forEach(cell => {
      maxWidth = Math.max(maxWidth, cell.scrollWidth);
    });

    const newWidth = maxWidth + 20;

    const updated = { ...columnWidths, [key]: newWidth };

    setColumnWidths(updated);

    Cookies.set(
      `InvoiceColumnWidths_${CompanyID}_${UserID}`,
      JSON.stringify(updated),
      { expires: 365 }
    );
  };
  const handleClosePrint = async () => {

    setShowPdfModal(false);

  };
  return (

    <div>
      {ClientCompanyID === 0 && (
        <Common showAddButton={'yes'} handleAddTask={handleCreateInvoiceClick}
          showDeleteButton={'yes'} handleDeleteItem={handleDeleteClick} ModuleID={"22"}
          showEmailButton={'yes'} handleSendEmail={handleSendMultipleEmail}
          showExportButton={'yes'} handleExportExcel={handleExportExcel}
          IsAttachment="1" isDisabled={multipleIds.length > 1}
          showSynchronize={'yes'} handleSynchronize={handleSynchronize}
          showPrintUser={'yes'} handlePrintUser={handlePrintUser}
          HelpFormName="Invoice List" HelpModule="38"
          showShippment={'yes'} handleShippment={handleShippment}
          handleShippmentTitle={"Post"} RecordID={multipleIds}
        />


      )}
      {loading && (
        <div class="loading">
          <div class="d-table">
            <div class="d-tablecell">
              <span class="loader">
                <span class="loader-inner"></span>
              </span>
            </div>
          </div>
        </div>
      )}
      <div className="main-content-header">
        <div className="row mb-3" style={{ marginLeft: "-5px" }}>
          {(ClientCompanyID === 0 &&
            <div className="col-xl-2">
              <h1>{t("invoiceHeader")}</h1>
            </div>
          )}
          {(ClientCompanyID > 0 &&
            <div className="col-xl-2">
              <button className='btn btn-primary btn-sm' onClick={handleCreateInvoiceClick}>
                <i className="icofont-plus" aria-hidden="true"> Add New</i>
              </button>
            </div>
          )}

          <div className="col-xl-10 d-flex justify-content-end">
            <ColumnOptionDropDown
              options={columnOptions}
              selectedOptions={visibleColumns}
              onChange={handleColumnChange}
            />

            {(ClientCompanyID > 0 &&
              <>
                <button style={{ padding: "5px 8px", marginRight: "5px" }} className='btn btn-success'
                  onClick={handlePayInvoice} disabled={multipleIds.length > 2}>
                  {t('pay')}
                </button>



              </>
            )}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card mb-30">
            <div className="card-body">

              <div className="">
                <div className="row mb-3">
                  <div className="col-sm-1">
                    <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={500}>500</option>
                      <option value={1000}>1000</option>
                    </select>
                  </div>
                  <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                  <div className="col-sm-6"></div>
                  <div className="col-sm-1 d-flex align-items-center justify-content-end">
                    <span className="me-2">Search</span>

                    <MultiSearchDropDown
                      options={columnSearchOptions}
                      selectedOptions={searchColumns}
                      onChange={handleSearchColumnChange}
                    />
                  </div>
                  <div className="col-sm-2 d-flex justify-content-end">
                    <input
                      list="recent-searches"
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="form-control me-2"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleSearchButtonClick();
                        }
                      }}
                    />
                    <datalist id="recent-searches">
                      {recentSearches.map((item, idx) => (
                        <option key={idx} value={item.SearchQuery} />
                      ))}
                    </datalist>
                    <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                      <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                    </button>
                  </div>



                </div>
                <div style={{ maxHeight: "80vh", overflow: "auto" }}>
                  <table
                    style={{
                      tableLayout: "fixed",
                      width: "max-content",
                      minWidth: "100%"
                    }}
                    className="table m-0 table-hover"
                    ref={tableRef}
                  >
                    <thead classname="table-light" style={{ position: "sticky", top: 0, zindex: 2 }}>
                      <tr>
                        <th
                          className="checkbox-header"
                          style={{
                            width: "40px",
                            minWidth: "40px",
                            maxWidth: "40px",
                            position: "sticky",
                            left: 0,
                            zIndex: 5,

                          }}
                        ></th>
                        {visibleColumns.includes("InvoiceNo") &&
                          <th onClick={() => handleSort('PK_Invoice_ID')}

                            style={{
                              width: `${columnWidths?.PK_Invoice_ID}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Invoice No.
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'PK_Invoice_ID'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "PK_Invoice_ID");
                              }}
                              onDoubleClick={() => autoFitColumn("PK_Invoice_ID")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("SSource") &&
                          <th onClick={() => handleSort('vc_Name')}

                            style={{
                              width: `${columnWidths?.vc_Name}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Source
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_Name'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_Name");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_Name")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("SourceNumber") &&
                          <th onClick={() => handleSort('SourceNumber')}

                            style={{
                              width: `${columnWidths?.SourceNumber}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Source No.
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'SourceNumber'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "SourceNumber");
                              }}
                              onDoubleClick={() => autoFitColumn("SourceNumber")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("SType") &&
                          <th onClick={() => handleSort('createdFrom')}

                            style={{
                              width: `${columnWidths?.createdFrom}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Type
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'createdFrom'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "createdFrom");
                              }}
                              onDoubleClick={() => autoFitColumn("createdFrom")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("SStatus") &&
                          <th onClick={() => handleSort('SStatus')}

                            style={{
                              width: `${columnWidths?.SStatus}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Status
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'Status'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "SStatus");
                              }}
                              onDoubleClick={() => autoFitColumn("SStatus")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("SDate") &&
                          <th onClick={() => handleSort('dt_InvoiceDate')}

                            style={{
                              width: `${columnWidths?.dt_InvoiceDate}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Date
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'dt_InvoiceDate'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "dt_InvoiceDate");
                              }}
                              onDoubleClick={() => autoFitColumn("dt_InvoiceDate")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("SDescription") &&
                          <th onClick={() => handleSort('CompanyName')}

                            style={{
                              width: `${columnWidths?.CompanyName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Company
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'CompanyName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "CompanyName");
                              }}
                              onDoubleClick={() => autoFitColumn("CompanyName")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("ISiteName") &&
                          <th onClick={() => handleSort('SiteName')}

                            style={{
                              width: `${columnWidths?.ISiteName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Site
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'SiteName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "SiteName");
                              }}
                              onDoubleClick={() => autoFitColumn("SiteName")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("Semail") && <th

                          style={{
                            width: `${columnWidths?.Email}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">Email<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "Email");
                            }}
                            onDoubleClick={() => autoFitColumn("Email")}
                          /></th>}
                        {visibleColumns.includes("SAmount") &&
                          <th onClick={() => handleSort('SAmount')}

                            style={{
                              width: `${columnWidths?.SAmount}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Amount
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'SAmount'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "SAmount");
                              }}
                              onDoubleClick={() => autoFitColumn("SAmount")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("SPaid") && <th
                          onClick={() => handleSort('SPaid')}
                          style={{
                            width: `${columnWidths?.SPaid}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">Paid<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "SPaid");
                            }}
                            onDoubleClick={() => autoFitColumn("SPaid")}
                          /></th>}
                        {visibleColumns.includes("SPrinted") && <th

                          style={{
                            width: `${columnWidths?.SPrinted}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">Printed<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "SPrinted");
                            }}
                            onDoubleClick={() => autoFitColumn("SPrinted")}
                          /></th>}
                        {visibleColumns.includes("SShipped") && <th

                          style={{
                            width: `${columnWidths?.SShipped}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">Posted<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "SShipped");
                            }}
                            onDoubleClick={() => autoFitColumn("SShipped")}
                          /></th>}
                        {visibleColumns.includes("ModifiedBy") &&
                          <th onClick={() => handleSort('ModifiedBy')}
                            style={{
                              width: `${columnWidths?.ModifiedBy}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Modified By
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'ModifiedBy'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i>
                            <div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "ModifiedBy");
                              }}
                              onDoubleClick={() => autoFitColumn("ModifiedBy")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("SSync") && <th

                          style={{
                            width: `${columnWidths?.SSync}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">Sync<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "SSync");
                            }}
                            onDoubleClick={() => autoFitColumn("SSync")}
                          /></th>}
                      </tr>
                    </thead>
                    <tbody>
                      {InvoiceList.map((invoice, index) => (

                        <tr key={invoice.PK_Invoice_ID}
                          onClick={() => handleEditClick(invoice.PK_Invoice_ID)}
                          style={{
                            backgroundColor: selectedId.toString() === invoice.PK_Invoice_ID.toString() ? 'rgb(197, 218, 237)' : '', // Highlight background
                            cursor: 'pointer',
                          }}>
                          <td
                            className="checkbox-cell"
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              width: "40px",
                              minWidth: "40px",
                              maxWidth: "40px",
                              position: "sticky",
                              left: 0,
                              zIndex: 3,
                              backgroundColor:
                                selectedId.toString() === invoice.PK_Invoice_ID.toString()
                                  ? 'rgb(197, 218, 237)'
                                  : '#fff'
                            }}
                          >
                            <div
                              className="checkbox-hover-area"
                              onClick={(event) => handleCheckboxClick(event, invoice.PK_Invoice_ID, index)}
                            >
                              <input
                                type="checkbox"
                                checked={multipleIds.includes(invoice.PK_Invoice_ID)}
                                readOnly
                              />
                            </div>
                          </td>
                          {visibleColumns.includes("InvoiceNo") && <td style={{
                            width: columnWidths.InvoiceNo,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{invoice.bnt_OrderNumber}</td>}
                          {visibleColumns.includes("SSource") && <td style={{
                            width: columnWidths.SSource,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={invoice.InvoiceName}>{invoice.InvoiceName}</td>}
                          {visibleColumns.includes("SourceNumber") && <td style={{
                            width: columnWidths.SourceNumber,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={invoice.SourceNumber}>{invoice.SourceNumber}</td>}
                          {visibleColumns.includes("SType") && <td style={{
                            width: columnWidths.SType,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={invoice.vc_Name}>{invoice.vc_Name}</td>}
                          {visibleColumns.includes("SStatus") && <td style={{
                            width: columnWidths.SStatus,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={invoice.vc_StatusName}>{invoice.vc_StatusName}</td>}
                          {visibleColumns.includes("SDate") && <td style={{
                            width: columnWidths.dt_InvoiceDate,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{formatDate(invoice.dt_InvoiceDate)}</td>}
                          {visibleColumns.includes("SDescription") && <td style={{
                            width: columnWidths.CompanyName,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={invoice.CompanyName}>{invoice.CompanyName}</td>}

                          {visibleColumns.includes("ISiteName") && <td style={{
                            width: columnWidths.SiteName,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={invoice.SiteName}>{invoice.SiteName}</td>}

                          {visibleColumns.includes("Semail") && <td style={{
                            width: columnWidths.Email,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={invoice.Email}>
                            <a href='#' onClick={(event) => handleEmailClick(event, invoice)}>
                              {invoice.Email}
                            </a>
                          </td>}
                          {visibleColumns.includes("SAmount") && <td style={{
                            width: columnWidths.SAmount,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={invoice.Total}>{invoice.Total}</td>}

                          {visibleColumns.includes("SPaid") && <td style={{
                            width: columnWidths.SPaid,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={invoice.Paid}>
                            {invoice.Paid}


                          </td>}

                          {visibleColumns.includes("SPrinted") && <td style={{
                            width: columnWidths.SPrinted,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={invoice.bit_Print}>

                            {invoice.bit_Print?.toString() === "1" && (
                              <img src='assets/img/resources/tick.png' style={{ width: "20px" }}></img>
                            )}


                          </td>}


                          {visibleColumns.includes("SShipped") && <td style={{
                            width: columnWidths.vc_Company,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{invoice.Shippment}</td>}

                          {visibleColumns.includes("ModifiedBy") && <td style={{
                            width: columnWidths.ModifiedBy,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">
                            {invoice.ModifiedBy ? (
                              <div
                                title={invoice.ModifiedBy}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "50%",
                                  backgroundColor: "#368938",
                                  color: "white",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                {invoice.ModifiedBy.split(" ")
                                  .map(word => word.charAt(0).toUpperCase())
                                  .join("")}
                              </div>
                            ) : (
                              ""
                            )}
                          </td>}

                          {visibleColumns.includes("SSync") &&
                            <td style={{
                              width: columnWidths.SSync,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis">

                              {invoice.IsSynced === 1 && (
                                <img src='assets/img/resources/tick.png' style={{ width: "20px" }}></img>
                              )}
                              {invoice.IsSynced === 2 && (
                                <img src='assets/img/resources/sync.JPG' style={{ width: "50px" }}></img>
                              )}

                            </td>
                          }

                        </tr>
                      ))}
                    </tbody>
                    <tfoot style={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "white" }}>
                      <tr>
                        <td colSpan={visibleColumns.length + 1}>
                          <div className="pagination-controls" style={{ marginTop: "10px", marginBottom: "10px" }}>
                            Showing {1 + (currentPage * pageSize) - pageSize} to {currentPage * (Math.min(soCount, pageSize))} of {soCount} entries

                            {/* Last Page Button */}
                            <button
                              style={{ float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(totalPages)} // Navigate to last page
                              disabled={currentPage === totalPages}
                            >
                              <img src="assets/img/resources/last.png" alt="Add icon" style={{ height: "10px" }} /> Last
                            </button>

                            {/* Next Page Button */}
                            <button
                              style={{ float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                            >
                              <img src="assets/img/resources/next-icon.png" alt="Add icon" style={{ height: "10px" }} /> Next
                            </button>

                            <span style={{ marginLeft: "10px", marginRight: "10px", float: "right" }}>
                              Page {currentPage} of {totalPages}
                            </span>

                            {/* Previous Page Button */}
                            <button
                              style={{ float: "right", marginRight: "5px", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                            >
                              <img src="assets/img/resources/pevious-icon.png" alt="Add icon" style={{ height: "10px" }} /> Prev
                            </button>

                            {/* First Page Button */}
                            <button
                              style={{ float: "right" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(1)} // Navigate to first page
                              disabled={currentPage === 1}
                            >
                              <img src="assets/img/resources/first.png" alt="Add icon" style={{ height: "10px" }} />  First
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>




                </div>
                {(ClientCompanyID > 0 &&
                  <div
                    className="footer-summary"
                    style={{
                      position: "sticky",
                      bottom: 0,
                      zIndex: 10,
                      backgroundColor: "white",
                      borderTop: "1px solid #ddd",
                      boxShadow: "0 -2px 5px rgba(0,0,0,0.1)",
                      padding: "10px 0"
                    }}
                  >
                    <table style={{ tableLayout: "fixed", marginBottom: 0, width: "50%" }}>
                      <thead className="table-light">
                        <tr>
                          <th>0-30 Days</th>
                          <th>31-60 Days</th>
                          <th>61-90 Days</th>
                          <th>91-120 Days</th>
                          <th>121+ Days</th>
                        </tr>
                      </thead>
                      <tbody>
                        {invoiceAgedSummary.map((invoice, index) => (
                          <tr key={index}>
                            <td>{invoice.FirstMonth}</td>
                            <td>{invoice.SecondMonth}</td>
                            <td>{invoice.ThirdMonth}</td>
                            <td>{invoice.FourthMonth}</td>
                            <td>{invoice.Remaining}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {isModalOpen && (
                  <InvoiceDetailModal InvoiceID={localStorage.getItem('InvoiceID')} onClose={handleCloseModal} onSuccess={fetchInvoice} ClientCompanyID={ClientCompanyID} />
                )}
                {showShippedModal && bnt_OrderNumber &&
                  <InvoiceShippedModel
                    show={showShippedModal}
                    OnSuccess={handleSuccess}
                    onClose={handleCloseShippmentModal}
                    parts={partList}
                    setParts={setPartData}
                    bnt_OrderNumber={bnt_OrderNumber}
                    InvoiceID={multipleIds[0]}


                  />
                }
                {showPayModal && (
                  <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Pay Invoice</h5>
                          <button type="button" className="btn-close" onClick={() => setShowPayModal(false)}></button>
                        </div>
                        <div className="modal-body">
                          <div className="row">
                            <div className="col-xl-12">
                              <div className="card mb-30">
                                <div className="card-body">


                                  <div className="row mb-3">
                                    <label htmlFor="CustomerID" className="col-sm-4 col-form-label">Amount:<span style={{ "color": "red" }}>*</span></label>
                                    <div className="col-sm-6">
                                      <input
                                        type="number"
                                        className="form-control"
                                        value={payAmount}
                                        onChange={(e) => setPayAmount(e.target.value)}
                                      />


                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button className="btn btn-secondary" onClick={() => setShowPayModal(false)}>Cancel</button>
                          <button className="btn btn-primary" onClick={handleSubmitPayment}>Submit</button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>


      {isEmailModalOpen && (
        <SendEmail onClose={handleCloseEmailModal} ToEmail={Email} Module="Customer" ModuleID={ContactIDForEmail} />
      )}
      {isMultipleEmailModalOpen && (
        <SendAttachment onClose={handleCloseEmailModal} ToEmail={multipleEmails} pdfAttachment={pdfAttachment} ReportName="Invoice.pdf" />

      )}
      {showPdfModal && pdfUrl && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <Draggable handle=".modal-content" onStart={handleStart}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">PDF Report</h5>
                  <button type="button" className="close" onClick={handleClosePrint}>
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                </div>
              </div>
            </Draggable>
          </div>
        </div>
      )}
    </div>


  );
}
export default InvoiceList;

